module.exports = __webpack_public_path__ + "img/demo_user.75ceead0.svg";